// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Heading_wrapper__AH_3x","content":"Heading_content__MIuti","description":"Heading_description__bXE8y","columns":"Heading_columns__0AJQS","column":"Heading_column__jJkkx"};